export interface Tag {
	tag_id: string;
	name: string;
}

export interface Creation {
	creation_id: string;
	title: string;
	tags: {
		tag_id: string;
		name: string;
	}[];
	brief_introduction: string;
	cover_image: string;
	anonymous: true;
	detailed_introduction: string;
	system_role: string;
	user_identity: string;
	main_characters: string;
	npc: string;
	reply_format: string;
	reply_example: string;
	world_books: {
		entry_name: string;
		keywords: string[];
		trigger_mode: string;
		keyword_mode: string;
		entry_content: string;
	}[];
	keywords: string[];
	trigger_mode: string;
	keyword_mode: string;
	entry_content: string;
	background_image: string;
	prologue: string;
	status: string;
	popularity: 0;
	view_count: string;
	paid_user_count: string;
	gem_consumption_count: 0;
	score: 0;
	author: {
		user_id: string;
		region: string;
		name: string;
		avatar: string;
	};
	edit_mode: string;
	created_time: number;
	updated_time: number;
	latest_edit_time: string;
}

export interface CreationList {
	total: number;
	list: Creation[];
}

export enum QueryCreationOrderField {
	QUERY_CREATION_ORDER_FIELD_UNSPECIFIED = "QUERY_CREATION_ORDER_FIELD_UNSPECIFIED",
	// 推荐
	RECOMMEND = "RECOMMEND",
	// 热度
	POPULARITY = "POPULARITY",
	// 评分
	SCORE = "SCORE",
	// 更新时间
	UPDATE_TIME = "UPDATE_TIME",
}
